// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/tag/style/index.less
// module id = 1169
// module chunks = 0